import { Trans } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './ApplicationLoader.module.css';
import Spinner from '../Spinner/Spinner';

const ApplicationLoader = () => {
  return (
    <div className={clsx(styles.container, styles.loadingContainer)}>
      <h1 className={styles.loadingHeading}>
        <Trans>We’re checking your application...</Trans>
      </h1>
      <h2 className={styles.loadingSubHeading}>
        <Trans>This may take up to 60 seconds</Trans>
      </h2>
      <div className={styles.spinnerContainer}>
        <Spinner />
      </div>
    </div>
  );
};

export default ApplicationLoader;
